import React, { useState } from 'react';

/**
 * ShareButton Component
 * Generates and copies shareable link for the report
 * 
 * Features:
 * - Copy to clipboard
 * - Visual feedback
 * - Share link generation
 */
const ShareButton = ({ reportId }) => {
  const [isCopied, setIsCopied] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);

  const handleShare = async () => {
    if (!reportId || isGenerating) return;

    setIsGenerating(true);

    try {
      // Generate share link
      const shareUrl = `${window.location.origin}/reports/${reportId}`;

      // Copy to clipboard
      await navigator.clipboard.writeText(shareUrl);

      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 3000);

      console.log('[SHARE] Link copied:', shareUrl);
    } catch (error) {
      console.error('[SHARE] Error:', error);
      alert('Fehler beim Kopieren: ' + error.message);
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <button
      onClick={handleShare}
      disabled={isGenerating}
      className={`relative px-4 py-2 bg-white/90 hover:bg-white text-gray-800 rounded-lg shadow-lg backdrop-blur-sm transition-all duration-200 ${
        isGenerating ? 'opacity-50 cursor-not-allowed' : 'hover:scale-105'
      }`}
      title="Link teilen"
    >
      <div className="flex items-center space-x-2">
        {isCopied ? (
          <>
            <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-sm font-medium text-green-600">Kopiert!</span>
          </>
        ) : (
          <>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
            </svg>
            <span className="text-sm font-medium">Teilen</span>
          </>
        )}
      </div>
    </button>
  );
};

export default ShareButton;

